import { CLIENT, ENV } from '../config';

const staging = 'staging';
const production = 'prod';
const trialProd = 'trial-prod';
const liteStaging = 'litestaging';
const liteProd = 'liteprod';
const apollo = 'apollo';

const isEnv = (environments: string[]): boolean => {
  return environments.includes(ENV);
};

export const isProductionEnv = (): boolean => (ENV === 'prod' || ENV === 'production');
export const isDevelopEnv = (): boolean => (ENV === 'dev' || ENV === 'development');

export const isOnlyRelease = (): boolean => isEnv([staging, liteStaging]);
export const isOnlyProduction = (): boolean => isEnv([production, 'production', trialProd, liteProd]);

export const isApollo = (): boolean => {
  return CLIENT === apollo;
};
